'use strict';
/**
 * [init initilizes tabs]
 * @param  {[string]} scope [css selector]
 * @return {[undefined]}    [nothing returned]
 */
export function init(scope) {

    var clearText = function() {
        $('#footer-newsletter-form').find('input:not(#FormcaptureAction)').val('');
    };


    alertify.newsletterSuccess = function (msg) {
        alertify.set({ labels: { ok: 'Luk' } });
        alertify.alert('<h3>' + msg + '</h3><div class="btn-row"><button class="btn btn--primary btn--full">Luk</button></div>', clearText(), 'newsletter-dialog');
    };

    if ($('#footer-newsletter-form').length) {

        /**
         * onfoucusout and element shifting position bug
         */
        var fsubmit = true;
        $('#footer-newsletter-form .btn--primary').on('mousedown touchend click', function(e) {
            if(fsubmit){
                fsubmit = false;
                // Double submit hack fix
                setTimeout(function(){
                    fsubmit = true;
                }, 500);

                $('#footer-newsletter-form').submit();
            }
            return false;
        });


        $('#footer-newsletter-form').on('submit', function(e) {
            var form = $('#footer-newsletter-form');

            if (form.valid()) {
                var url = form.attr('action');
                var submitBtn = form.find('[type=submit]');

                submitBtn.addClass('btn--disabled');

                $.ajax({
                    type: 'POST',
                    url: url,
                    data: $(this).serialize(),
                    success: function(data) {
                        if (data.success) {
                            form.find('.btn').focus();
                            alertify.newsletterSuccess(data.msg);
                        } else if (data.url) {
                            window.location.href = url;
                        } else {
                            alertify.alert(data.msg);
                        }
                        submitBtn.removeClass('btn--disabled');
                    },
                    error: function() {
                        alertify.alert('server side fejl');
                        submitBtn.removeClass('btn--disabled');
                    }
                });

                e.preventDefault();
            }
        });
    }

    if($('#full-newsletter-form').length){

        /**
         * onfoucusout and element shifting position bug
         */
        var nsubmit = true;
        $('#full-newsletter-form .btn--primary').on('mousedown touchend click', function(e) {
            if(nsubmit){
                nsubmit = false;
                // Double submit hack fix
                setTimeout(function(){
                    nsubmit = true;
                }, 500);

                $('#full-newsletter-form').submit();
            }
            return false;
        });

        $('#full-newsletter-form').on('submit', function(e) {
            var form = $('#full-newsletter-form');

            if (form.valid()) {
                var url = form.attr('action');
                var submitBtn = form.find('[type=submit]');

                submitBtn.addClass('btn--disabled');
                var errorsDiv = $('#newsletter-errors');

                $.ajax({
                    type: 'POST',
                    url: url,
                    data: $(this).serialize(),
                    success: function(data) {
                        if (data.success) {
                            errorsDiv.hide();
                            form.html($('div#success-newsletter').html());
                        } else if (data.url) {
                            window.location.href = data.url;
                        } else {
                            errorsDiv.find('p').text(data.msg);
                            errorsDiv.show();
                        }
                        submitBtn.removeClass('btn--disabled');
                    },
                    error: function() {
                        errorsDiv.find('p').text('server side fejl');
                        errorsDiv.show();
                        submitBtn.removeClass('btn--disabled');
                    }
                });

                e.preventDefault();
            }
        });
    }

    if ($('#newsletter-settings-form').length) {

        $('#save-newsletter-settings').on('click', function(e) {
            var form = $('#newsletter-settings-form');
            var url = form.attr('action');

            if (form.valid()) {
                var submitBtn = $(this);

                submitBtn.addClass('btn--disabled');
                var errorsDiv = $('#newsletter-settings-errors');
                var successDiv = $('#newsletter-settings-success');


                $.ajax({
                    type: 'POST',
                    url: url,
                    data: form.serialize(),
                    success: function(data) {
                        if (data.success) {
                            errorsDiv.hide();
                            successDiv.show().fadeOut(7000);

                            var hiddenEmailField = $('#newsletter-settings-hidden-email');
                            hiddenEmailField.val(data.data.email);
                        } else {
                            successDiv.hide();
                            errorsDiv.find('p').text(data.msg);
                            errorsDiv.show();
                            $('html, body').animate({ scrollTop: 0 }, 500);
                        }
                        submitBtn.removeClass('btn--disabled');
                    },
                    error: function() {
                        successDiv.hide();
                        errorsDiv.find('p').text('server side fejl');
                        errorsDiv.show();
                        $('html, body').animate({ scrollTop: 0 }, 500);
                        submitBtn.removeClass('btn--disabled');
                    }
                });
            } else {
                form.submit();
            }
            e.preventDefault();
        });

        //$('input:radio').on('click', function() {
        //    var isMember = $('input#isMember').is(':checked');
        //    var numberInput = $('input#member-number');
        //    numberInput.attr('disabled', !isMember);
        //    if (!isMember) {
        //        numberInput.val('');
        //        numberInput.valid();
        //    }
        //});
    }


    $('body').on('click touchend', '.newsletter-dialog .btn, .alertify-cover', function(ev){
        $('.alertify-button-ok').trigger('click');
        return false;
    });

}
